import { render, staticRenderFns } from "./ClinicsResult.vue?vue&type=template&id=9b40920c&"
import script from "./ClinicsResult.vue?vue&type=script&lang=js&"
export * from "./ClinicsResult.vue?vue&type=script&lang=js&"
import style0 from "./ClinicsResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports